document.addEventListener('DOMContentLoaded', function() {
    // 価格を更新する関数
    function updatePrice() {
        var variantSelectsElement = document.querySelector('variant-selects');
        var priceDisplay = document.querySelector('num');
        var quantityInput = document.querySelector('quantity-input input');
        let quantity = parseInt(quantityInput.value);
        let price = 0;

        if (variantSelectsElement) {
            var variantsJson = JSON.parse(variantSelectsElement.querySelector('script[type="application/json"]').textContent);
            var params = new URLSearchParams(window.location.search);
            var variantId = params.get('variant');
            let selectedVariant = variantsJson[0]; // デフォルトは最初の要素

            if (variantId) {
                selectedVariant = variantsJson.find(variant => variant.id.toString() === variantId);
            }
            price = selectedVariant.price / 100; // 価格を正しいフォーマットに変換
        } else {
            // バリエーションがない商品の場合、価格を直接取得
            var defaultPriceElement = document.querySelector('span.default-price');
            if (defaultPriceElement) {
                price = parseFloat(defaultPriceElement.textContent.replace(/[^\d]/g, ''));
            }
        }

        let totalPrice = price * quantity;
        priceDisplay.textContent = `${totalPrice.toLocaleString('ja-JP')}円`;
    }

    // オプション変更時のイベントリスナー
    $('body').on('change', 'variant-selects select.select__select', function() {
        updatePrice();
    });

    // 数量変更時のイベントリスナー
    $('body').on('change', 'quantity-input input', function() {
        updatePrice();
    });

    // 初期価格を設定
    updatePrice();
});